import { Injectable } from '@angular/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { BaseUrlService } from './base-url.service';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  constructor(
    private http: CsHttpClientService,
    private baseUrlService: BaseUrlService
  ) {}

  public fileSave(data: {
    file: File;
    containerName: string;
    canDownload?: boolean;
  }): Observable<string> {
    return this.http
      .writeMultipart<Array<{ fileDetailId: number; filePath: string }>>(
        'api/common/file/upload',
        data,
        this.baseUrlService.getApiBaseURL()
      )
      .pipe(map(resp => resp[0].filePath));
  }

  public multipleFileSave(data: {
    files: Array<File>;
    containerName: string;
  }): Observable<Array<string>> {
    return this.http
      .writeMultipart<Array<{ fileDetailId: number; filePath: string }>>(
        'api/common/file/upload',
        data,
        this.baseUrlService.getApiBaseURL()
      )
      .pipe(map(resp => resp.map(_ => _.filePath)));
  }

  public identityFileSave(data: {
    file: File;
    containerName: string;
  }): Observable<string> {
    return this.http
      .writeMultipart<Array<{ fileDetailId: number; filePath: string }>>(
        'api/common/file/upload',
        data,
        this.baseUrlService.getIdentityBaseURL()
      )
      .pipe(map(resp => resp[0].filePath));
  }
}
